import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Edit from 'react-icons/lib/md/create';
import {withTranslation} from 'react-i18next';

import { Button } from '../button/Button';
import { UnofficialResults } from '../modal/UnofficialResults';
import { unofficialResults } from './styles';

class AddUnofficialResultComponent extends Component {
  static propTypes = {
    raceResultToggled: PropTypes.func,
    eventId: PropTypes.number,
    options: PropTypes.array,
    t: PropTypes.func
  };

  state = {
    open: false,
    success: false
  };

  handleOpen = () => this.setState({open: true});

  handleClose = () => this.setState({open: false});

  onTouchTap = () => this.props.modal.props.isLoggedIn ?
    this.handleOpen() : this.props.modal.handleTouchTap();

  handler = () => this.setState({success: true});

  render() {
    const {
      isMobile,
      result,
      modal,
      t
    } = this.props;
    //We don't want "all race types" as an option
    const filteredOptions = modal.props && modal.props.options && Array.isArray(modal.props.options)
      ? modal.props.options.filter((option) => option.value > 0)
      : undefined;

    return (
      <div id='add-your-time'>
        {modal.props.buttonMode === 'addNew' ?
          <Button
            style={unofficialResults.buttonStyle}
            handleClick={this.onTouchTap}
            onTouchTap={this.onTouchTap}
            text={modal.props.text ? modal.props.text : t('Add Your Time')}
            color='actualWhite'
            link=''/>
          :
          <Edit size="20"
                onClick={this.onTouchTap}
                style={unofficialResults.editIcon}/>
        }
          <UnofficialResults
            handler = {this.handler}
            isMobile={isMobile}
            eventCourseID={modal.props.eventCourseId}
            eventId={modal.props.eventId}
            unofficial={modal.props.unofficial}
            athleteList={modal.props.athleteList}
            open={this.state.open}
            mode={modal.props.buttonMode}
            handleOpen={this.handleOpen}
            handleClose={this.handleClose}
            races={modal.props.races}
            options={filteredOptions}
            result={result}/>
      </div>
    );
  }
}

export const AddUnofficialResult = withTranslation()(AddUnofficialResultComponent);



/** WEBPACK FOOTER **
 ** ./components/control/AddUnofficialResult.js
 **/